import { PRIORITY, type Priority } from './tokens'

interface Props {
  priority: string
  className?: string
}

export function PriorityBadge({ priority, className = '' }: Props) {
  const key = (priority?.toLowerCase() ?? 'low') as Priority
  const token = PRIORITY[key] ?? PRIORITY.low
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${token.badge} ${className}`}
      aria-label={`Priority: ${token.label}`}
    >
      <span aria-hidden="true">{token.icon}</span>
      {token.label}
    </span>
  )
}
